import * as React from 'react';
import { rem } from 'polished';

import type { LinkType } from '../link';

import { styled } from './themeContext';
import Link from './Link';
import naverCafeUrl from './naverCafeButton/naverCafeLogo.png';

type NaverCafeButtonProps = {
  naverCafeLink?: LinkType,
  cafeButtonText?: string,
};

const Container = styled.div({
  cursor: 'pointer',
  pointerEvents: 'all',
});

const ButtonText = styled.span({
  position: 'absolute',
  opacity: 0,
})

const NaverCafeImg = styled.img((props) => ({
  width: rem(43),
  height: rem(60),
  [props.theme.media['md']]: {
    width: rem(83),
    height: rem(114),
  },
}));

const NaverCafeButton: React.FC<NaverCafeButtonProps> = ({
  naverCafeLink,
  cafeButtonText,
}) => {
  return (
    <Container>
      <Link link={naverCafeLink}>
        <ButtonText>{cafeButtonText}</ButtonText>
        <NaverCafeImg src={naverCafeUrl} />
      </Link>
    </Container>
  );
};

export default NaverCafeButton;
